import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useData } from "@/context/DataContext";
import { ROLES } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const HINTS = {
  dashboard: "La situazione del giorno: ordini aperti, urgenze e scadenze SLA.",
  orders: "Tutti gli ordini e i ticket, con stato, storico e rapportini.",
  import: "Carica i file degli ordini ricevuti dai committenti.",
  planning: "Assegna gli interventi alle squadre trascinandoli nel calendario.",
  production: "Controlla e valida i rapportini prima della contabilizzazione.",
  projects: "Commesse, contratti e listini prezzi dei committenti.",
  resources: "Tecnici, squadre, turni e assenze.",
  warehouse: "Giacenze, furgoni, movimenti, inventari e ordini ai fornitori.",
  fleet: "Mezzi, attrezzature, manutenzioni e scadenze.",
  accounting: "Fatture attive e passive, incassi, pagamenti e solleciti.",
  personnel: "Dipendenti, contratti, abilitazioni, presenze e verbali di consegna.",
  control: "Budget, consuntivo, produttività e report mensile di direzione.",
  registry: "Clienti, fornitori e committenti.",
  group: "Società, sedi, utenti, reparti e permessi.",
  audit: "Chi ha modificato cosa e quando.",
  settings: "Collegamenti e impostazioni generali.",
};

export const WelcomeGuide = ({ items, open, onClose }) => {
  const { user, setUser } = useAuth();
  const { visibleCompanies } = useData();
  const close = async () => {
    onClose();
    if (!user.onboarded_at) {
      setUser({ ...user, onboarded_at: new Date().toISOString() });
      api.post("/auth/onboarded").catch(() => {});
    }
  };
  const scope = user.role === "admin" || user.group_scope ? "tutte le società del gruppo" : visibleCompanies.map((c) => c.legal_name).join(", ") || "nessuna società assegnata";
  const role = user.role === "direzione" && !user.group_scope ? "Direzione società" : ROLES[user.role];
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto" data-testid="welcome-guide">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Ciao {user.name.split(" ")[0]}, benvenuto in Elysium ERP</DialogTitle>
          <DialogDescription data-testid="welcome-guide-scope">
            Accedi come <b>{role}</b>{user.department_labels?.length > 0 && <> del reparto <b>{user.department_labels.join(", ")}</b></>} e vedi i dati di <b>{scope}</b>{scope.endsWith(".") ? "" : "."}
            {user.department_labels?.length > 0 && " Le aree qui sotto sono quelle del tuo reparto; ordini e anagrafiche sono sempre consultabili."}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-2 sm:grid-cols-2">
          {items.map((n) => (
            <div key={n.id} className="flex gap-3 border p-3" data-testid={`welcome-area-${n.id}`}>
              <n.icon className="mt-0.5 h-5 w-5 shrink-0 text-primary" />
              <div><div className="text-sm font-semibold">{n.label}</div><div className="text-xs text-muted-foreground">{HINTS[n.id]}</div></div>
            </div>
          ))}
        </div>
        <p className="text-xs text-muted-foreground">In alto puoi scegliere la società su cui lavorare; la campanella raccoglie urgenze e scadenze. Puoi riaprire questa guida dal menu con il tuo nome.</p>
        <Button onClick={close} className="w-full sm:w-auto sm:justify-self-end" data-testid="welcome-guide-close">Ho capito, iniziamo</Button>
      </DialogContent>
    </Dialog>
  );
};
